<template>
    <div id="meters-report" class="pt-8">
        <labeled-card :label="$t('Отчет по выданным Досудебным уведомлениям')">
            <v-container fluid class="pl-4">
                <v-row>
                    <v-col cols="3">
                        <v-radio-group row v-model="report_category">
                            <v-radio
                                color="gray"
                                v-for="category in report_categories"
                                :key="category.label"
                                :label="category.label"
                                :value="category.value"
                            ></v-radio
                        ></v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <pre-trial-date-picker label="Период выдачи уведомления" isRange :date.sync="period" />
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            outlined
                            :label="$t('Инженер ЭР')"
                            :items="itemsEngineer"
                            item-text="person_ea_name_show"
                            item-value="isas_engineer_rid"
                            v-model="engineer_rid"
                            :disabled="!isRoleManagementReport"
                            multiple
                            clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            label="Сумма долга по основным услугам"
                            color="gray"
                            append-icon="search"
                            outlined
                            type="number"
                            hide-spin-buttons
                            v-model="sum_debt"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="3" md="4" sm="6">
                        <v-btn class="spacer" :loading="isLoading" dark color="info" @click.stop="generateReport">{{ $t('reports.labels.button') }}</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </labeled-card>
    </div>
</template>

<script>
import PreTrialDatePicker from '@/components/pre-trial-notices/PreTrialDatePicker.vue';
import LabeledCard from '@/components/ui/LabeledCard';
import translate from '@/utils/translate.util';
import { mapState, mapActions } from 'vuex';
export default {
    name: 'ReportPreTrialNoticesIssued',
    components: {
        PreTrialDatePicker,
        LabeledCard
    },
    data: () => ({
        period: null,
        isLoading: false,
        report_category: false,
        sum_debt: null,
        engineer_rid: null,
        report_categories: [
            { label: 'Юридические лица', value: false },
            { label: 'Физические лица', value: true }
        ]
    }),
    methods: {
        ...mapActions('users', ['getEngList', 'getUserInfo']),
        async generateReport() {
            this.isLoading = true;
            if (!this.period) {
                this.$store.dispatch('base/showMessage', {
                    message: 'Не выбран период',
                    color: 'warning'
                });
                this.isLoading = false;
                return;
            }
            const response = await this.$store.dispatch('reports/getReportPreTrialNoticesIssued', {
                period: this.period,
                report_category: this.report_category,
                engineer_rid: this.engineer_rid,
                sum_debt: this.sum_debt
            });

            if (!response) {
                this.$store.dispatch('base/showMessage', {
                    message: 'Нет данных',
                    color: 'warning'
                });
            }
            this.isLoading = false;
        }
    },
    computed: {
        ...mapState('users', ['itemsEngineer', 'userInfo']),
        isRoleManagementReport() {
            return this.userInfo['role_code'] ? this.userInfo['role_code'].includes('management_reports') : false;
        }
    },
    async created() {
        await this.getUserInfo();
        await this.getEngList();
        if (this.userInfo['role_code'] && this.userInfo['role_code'].includes('management_reports')) {
            this.engineer_rid = [];
        } else if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_engineer_rid) {
            this.engineer_rid = [this.userInfo.user_data.isas_engineer_rid];
        }
    }
};
</script>

<style lang="scss" scoped>
#meters-report {
    height: 100%;
}
.label {
    font-weight: 500;
}
.spacer {
    width: 80%;
}
.picker * {
    margin-bottom: 0;
}

@media screen and (max-width: 1440px) {
    .spacer {
        width: 100%;
    }
}
</style>
